import { SelectorOption } from './modal-edit-constants';

export const toOptions = (values: string[]): SelectorOption[] =>
  values.map(value => ({ label: value, value }));

// Walks up from `root` looking for a flex item that grows (flex-grow > 0) but
// left `min-height` at its default `auto` -- the exact bug that lets a
// ModalEditWidget grow past its allotted space instead of scrolling
// internally (see "ModalEditWidget min-height:0 chain" in
// docs/MIGRATION_GUIDE.md). Stops at `document.body` since anything above
// that is outside the app's own layout. Scroll containers are skipped: a flex
// item with overflow other than `visible` already has a zero automatic minimum
// size per the flexbox spec (e.g. Page's `.body`, `overflow: auto`).
export const findBrokenFlexFillAncestor = (root: HTMLElement): HTMLElement | null => {
  let node = root.parentElement;

  while (node && node !== document.body) {
    const style = getComputedStyle(node);
    if (
      parseFloat(style.flexGrow) > 0 &&
      style.minHeight === 'auto' &&
      style.overflowY === 'visible'
    ) {
      return node;
    }
    node = node.parentElement;
  }

  return null;
};

/**
 * Returns a description of the first getRowId violation found, or null when every row maps to a
 * unique, defined key.
 */
export const findRowIdProblem = <T>(
  rows: readonly T[],
  getRowId: (row: T) => string
): string | null => {
  const seen = new Set<string>();

  for (const row of rows) {
    const id = getRowId(row);
    if (id == null || id === '') {
      return 'an empty key';
    }
    if (seen.has(id)) {
      return `a duplicate key ("${id}")`;
    }
    seen.add(id);
  }

  return null;
};
